import { hasStoryIdAssigned, ACTION_ROUTE_CHANGING } from '../routeReducer'
import { EllipsisTabs } from '../appReducer'

const stateWithPlanningTab = (state) => ({
  ...state,
  appState: {
    ...state.appState,
    activeTab: EllipsisTabs.Planning,
  },
})

export default function tabsReducer(state, action) {
  switch (action.type) {
    case ACTION_ROUTE_CHANGING: {
      // Switch to Planning tab for new story
      return hasStoryIdAssigned(state) ? state : stateWithPlanningTab(state)
    }
    default:
      return state
  }
}
